import { createSvgIcon } from '@mui/material/utils';

export const ArrowDown = createSvgIcon(
  <path d="M0 0.882812L5 5.88281L10 0.882812H0Z" fill="#6B7280" />,
  'ArrowDown',
);
